// extracted by mini-css-extract-plugin
module.exports =  {"root":"y0lI0xCPc5fbTALIKu6I","svg-inline--fa":"jy83ZNAMCaigAhIqQ476","svgInlineFa":"jy83ZNAMCaigAhIqQ476"};